import { Link } from "react-router-dom";
import { ArrowLeft, Volume2, VolumeX } from "lucide-react";
import { MOOD_STYLES } from "@/lib/journey";

export const CinematicTopBar = ({ liveMood, bedsOn, onToggleBeds }) => (
  <div className="flex items-center justify-between mb-10">
    <Link to="/dashboard" className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#78716C] hover:text-[#B45309] inline-flex items-center gap-2 transition-colors" data-testid="cinematic-back">
      <ArrowLeft size={12} /> Dashboard
    </Link>
    <span
      data-testid="cinematic-mood"
      className={`font-mono text-[10px] tracking-[0.35em] uppercase px-3 py-1.5 border transition-colors duration-1000 ${MOOD_STYLES[liveMood]}`}
    >
      § {liveMood}
    </span>
    <button
      onClick={onToggleBeds}
      data-testid="cinematic-bed-toggle"
      data-on={bedsOn ? "1" : "0"}
      title={bedsOn ? "Scene sound on" : "Scene sound off"}
      className={`ml-2 inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] uppercase px-3 py-1.5 border transition-colors ${bedsOn ? "border-[#E7DFD5] text-[#44403C] hover:border-[#F59E0B]" : "border-[#E7DFD5] text-[#44403C] hover:text-[#44403C]"}`}
    >
      {bedsOn ? <Volume2 size={12} /> : <VolumeX size={12} />} Scene sound
    </button>
  </div>
);
